import React from "react";
// import imgtest from "../Images/main.jpg";

const BigLocationCard = ({ data, onSelect }) => {
  return (
    <div className="w-full">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 justify-items-center max-w-7xl mx-auto px-4">
        {data.length === 0 ? (
          <div className="col-span-3 text-center text-gray-700 bg-white/60 rounded-md p-10 border border-dashed">
            No locations found.
          </div>
        ) : (
          data.map((loc, idx) => (
            <div
              key={loc.name || idx}
              className="relative w-full sm:w-[90%] md:w-72 aspect-square rounded-2xl overflow-hidden border border-white shadow-md group cursor-pointer"
              onClick={() => onSelect(loc)}
            >
              <img
                src={loc.img}
                alt={loc.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/50 transition group-hover:bg-gradient-to-br from-orange-500 to-green-900 group-hover:opacity-80" />
              <div className="relative z-10 h-full w-full flex flex-col justify-center items-center text-white text-center p-3">
                <span className="text-lg sm:text-xl md:text-xl font-semibold text-gray-900 px-3 py-1 bg-white/50 poppins-regular rounded-2xl">
                  {loc.name}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BigLocationCard;
